import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jobService } from "../TA/shared/services/jobService";
import "./MyJobs.css";

function MyJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMyJobs = async () => {
      try {
        setLoading(true);

        // Fetch jobs - same pattern as JobTracker
        const result = await jobService.getAllJobs();

        // Handle response format
        const jobList = Array.isArray(result) ? result : (result.data || []);

        // Filter for active statuses (Open, In Progress) and get top 5 most recent
        const activeStatuses = ["Open", "In Progress"];
        const activeJobs = jobList
          .filter(job => activeStatuses.includes(job.job_status))
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .slice(0, 5);

        setJobs(activeJobs);
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMyJobs();
  }, []);

  const getStatusClass = (status) => {
    const statusLower = status?.toLowerCase().replace(/\s+/g, "-") || "";
    return `job-status-badge job-status-${statusLower}`;
  };

  const calculateDaysOpen = (createdAt) => {
    if (!createdAt) return "-";
    const created = new Date(createdAt);
    const now = new Date();
    const diffTime = Math.abs(now - created);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const handleViewAll = () => {
    navigate("/ta/jobs");
  };

  if (loading) {
    return (
      <div className="my-jobs-container">
        <div className="my-jobs-loading">
          <div className="loading-spinner"></div>
          <span>Loading jobs...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="my-jobs-container">
      {jobs.length === 0 ? (
        <div className="my-jobs-empty">
          <div className="empty-icon">briefcase</div>
          <p>No active jobs found</p>
          <span>Open and In Progress jobs will appear here</span>
        </div>
      ) : (
        <>
          <div className="my-jobs-table-wrapper">
            <table className="my-jobs-table">
              <thead>
                <tr>
                  <th>Job Title</th>
                  <th>Job Status</th>
                  <th>Recruiter</th>
                  <th>Days Open</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((job, index) => (
                  <tr key={job.id || index}>
                    <td className="job-title-cell">
                      {job.job_title}
                    </td>
                    <td>
                      <span className={getStatusClass(job.job_status)}>
                        {job.job_status}
                      </span>
                    </td>
                    <td className="job-recruiter-cell">
                      {job.recruiter || "-"}
                    </td>
                    <td className="job-days-cell">
                      {calculateDaysOpen(job.created_at)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="my-jobs-footer">
            <button className="view-all-btn" onClick={handleViewAll}>
              View All Jobs
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default MyJobs;
